import { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './ui/button';
import { Progress } from 'components/ui/progress';

import MobileScanning from 'assets/images/mobile-scan-loading.png';
import useFaceScanStore from 'store/face-scan';

interface ScanProgressPreviewProps {
  progress: number;
  setProgress: Dispatch<SetStateAction<number>>;
  onClose: () => void;
  onCompletion?: () => void;
}

export default function ScanProgressPreview({
  progress,
  setProgress,
  onClose,
  onCompletion,
}: ScanProgressPreviewProps) {
  const { t } = useTranslation();

  const sdkConfig = useFaceScanStore((store) => store.sdkConfig);
  const processingTime = sdkConfig?.scan_duration || 0;

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          onCompletion?.();
          clearInterval(timer);
          return 100;
        }
        return prevProgress + 100 / +processingTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className='min-h-[calc(100vh-7rem)] grid place-content-center max-w-5xl mx-auto py-8 px-4'>
      <div className='flex flex-col gap-4 space-y-4 sm:space-y-6'>
        <h1 className='text-lg font-semibold leading-tight text-center'>
          {t('scan_in_other_device')}...
        </h1>

        <div className='relative w-full h-fit sm:h-80'>
          <img
            src={MobileScanning}
            alt='scan in progress'
            className='object-contain w-full h-full sm:object-cover'
          />

          <div className='absolute left-1/3 top-[35%] space-y-1'>
            <p className='text-sm text-center'>{t('scanning')}</p>
            <Progress value={progress} className='h-3 w-36 sm:w-52' />
          </div>
        </div>

        <div className='flex flex-col items-center justify-center gap-2'>
          <p>{t('wait_for_scan_completion')}</p>
          <Button className='px-6 h-9' onClick={onClose}>
            {t('close')}
          </Button>
        </div>
      </div>
    </div>
  );
}
